import { PRIMARY_OUTLET, Router } from "@angular/router";

// The broker sends the browser back to the broker accounts page with a one-time key in ?connection=. A tab that is
// signed out by then keeps the key here through the sign-in, never in an address: the sign-in page runs Google's script,
// and Google Tag Manager on every page reads addresses. The broker accounts page takes it when it next opens signed in;
// the API finishes the connection only for the user who started it.
export const BROKER_CONNECTION_KEY = "signInBrokerConnection";
const CONNECTION_PAGE = "broker-accounts";
const CONNECTION_PARAMETER = "connection";
// The API issues BROKER_OAUTH_CODE_ and 32 hex characters (FT.AutoTrader ReceiveBrokerConnectionCodeHandler). Anyone can
// make an address: a repeated ?connection= arrives as a list, and a huge value would make sessionStorage throw.
const CONNECTION_KEY_FORMAT = /^[A-Za-z0-9_]{1,128}$/;

export function isBrokerConnectionKey(value: unknown): value is string {
    return typeof value === "string" && CONNECTION_KEY_FORMAT.test(value);
}

// Only the key, and only from the broker accounts page's own address: no address is kept, so none is opened later.
export function saveBrokerConnection(router: Router, requestedUrl: string): void {
    const address = router.parseUrl(requestedUrl);
    const group = address.root.children[PRIMARY_OUTLET];
    const key: unknown = address.queryParams[CONNECTION_PARAMETER];
    if (
        isBrokerConnectionKey(key) &&
        address.root.numberOfChildren === 1 &&
        group?.numberOfChildren === 0 &&
        group.segments.length === 1 &&
        group.segments[0].path === CONNECTION_PAGE
    ) {
        sessionStorage.setItem(BROKER_CONNECTION_KEY, key);
    }
}

// Removed as it is read, so a kept key is sent at most once, whatever the answer.
export function takeBrokerConnection(): string | null {
    const key = sessionStorage.getItem(BROKER_CONNECTION_KEY);
    clearBrokerConnection();
    return key;
}

export function clearBrokerConnection(): void {
    sessionStorage.removeItem(BROKER_CONNECTION_KEY);
}
